/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_Componente__Dolar_95_36 as Componente__Dolar_95_36,
  rec_Componente_vDolar_118_36 as Componente_vDolar_118_36,
  rec_Di as Di,
  rec_Ei as Ei,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Ti as Ti,
  rec_d$ as d$,
  rec_wi as wi,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function TablaFlota(e) {
  let t = (0, ReactCompiler.c)(52),
    {
      titulo: n,
      descripcion: r,
      textoNuevo: i,
      onNuevo: a,
      busqueda: o,
      onBuscar: s,
      placeholderBusqueda: c,
      columnas: l,
      total: u,
      filas: d,
      cargando: f,
      textoVacio: p,
      textoSinCoincidencias: m,
      nombreDe: h,
      celdas: _,
      onEditar: v,
      onAlternar: y,
    } = e,
    b,
    x,
    S,
    C;
  if (
    t[0] !== o ||
    t[1] !== f ||
    t[2] !== _ ||
    t[3] !== l ||
    t[4] !== r ||
    t[5] !== d ||
    t[6] !== h ||
    t[7] !== y ||
    t[8] !== s ||
    t[9] !== v ||
    t[10] !== a ||
    t[11] !== c ||
    t[12] !== i ||
    t[13] !== m ||
    t[14] !== p ||
    t[15] !== n ||
    t[16] !== u
  ) {
    let e = d.slice(0, d$);
    b = `${Bo} flex flex-col gap-3`;
    let g;
    t[21] === u
      ? (g = t[22])
      : ((g = u > 0 && (
          <span className={`text-(--text)`} children={[`(`, u, `)`]} />
        )),
        (t[21] = u),
        (t[22] = g));
    let w;
    t[23] !== g || t[24] !== n
      ? ((w = (
          <p className={`font-medium text-(--text-h)`} children={[n, ` `, g]} />
        )),
        (t[23] = g),
        (t[24] = n),
        (t[25] = w))
      : (w = t[25]);
    let T;
    t[26] === r
      ? (T = t[27])
      : ((T = <p className={`text-sm text-(--text)`} children={r} />),
        (t[26] = r),
        (t[27] = T));
    let E;
    t[28] !== w || t[29] !== T
      ? ((E = <div className={`min-w-0`} children={[w, T]} />),
        (t[28] = w),
        (t[29] = T),
        (t[30] = E))
      : (E = t[30]);
    let D;
    t[31] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((D = <Ti className={`mr-1 inline h-3.5 w-3.5`} />), (t[31] = D))
      : (D = t[31]);
    let O;
    (t[32] !== a || t[33] !== i
      ? ((O = (
          <button
            type={`button`}
            onClick={a}
            className={`${zo} whitespace-nowrap`}
            children={[D, ` `, i]}
          />
        )),
        (t[32] = a),
        (t[33] = i),
        (t[34] = O))
      : (O = t[34]),
      t[35] !== O || t[36] !== E
        ? ((x = (
            <div
              className={`flex items-start justify-between gap-3`}
              children={[E, O]}
            />
          )),
          (t[35] = O),
          (t[36] = E),
          (t[37] = x))
        : (x = t[37]));
    let k;
    (t[38] === s
      ? (k = t[39])
      : ((k = (e) => s(e.target.value)), (t[38] = s), (t[39] = k)),
      t[40] !== o || t[41] !== c || t[42] !== k
        ? ((S = (
            <input
              type={`search`}
              value={o}
              onChange={k}
              placeholder={c}
              className={Lo}
            />
          )),
          (t[40] = o),
          (t[41] = c),
          (t[42] = k),
          (t[43] = S))
        : (S = t[43]),
      (C = f ? (
        <Componente__Dolar_95_36 />
      ) : u === 0 ? (
        <Componente_vDolar_118_36 texto={p} />
      ) : d.length === 0 ? (
        <p className={`text-sm text-(--text)`} children={m} />
      ) : (
        <div
          className={`overflow-y-auto rounded-xl border border-(--border)`}
          style={{
            maxHeight: `33.5rem`,
          }}
          children={
            <table
              className={`w-full text-left text-sm`}
              children={[
                <thead
                  className={`sticky top-0 bg-(--bg) text-xs text-(--text)`}
                  children={
                    <tr
                      className={`border-b border-(--border)`}
                      children={[
                        l.map((e, t) => (
                          <th
                            key={e}
                            className={`py-2 pr-3 font-medium ${t === 0 ? `pl-3` : ``} ${t > 0 && t < l.length - 1 ? `hidden sm:table-cell` : ``}`}
                            children={e}
                          />
                        )),
                        <th className={`w-20 py-2 pr-2`} />,
                      ]}
                    />
                  }
                />,
                <tbody
                  children={e.map((e) => (
                    <tr
                      key={e.id}
                      className={`group border-t border-(--border)/50 transition hover:bg-(--panel) ${e.activo ? `` : `opacity-55`}`}
                      children={[
                        _(e).map((t, n) => (
                          <td
                            key={n}
                            className={`max-w-0 py-1.5 pr-3 ${n === 0 ? `pl-3` : ``} ${n > 0 && n < l.length - 1 ? `hidden sm:table-cell` : ``}`}
                            children={[
                              t,
                              n === 0 && !e.activo && (
                                <span
                                  className={`ml-2 text-[10px] uppercase text-(--text)`}
                                  children={`sin uso`}
                                />
                              ),
                            ]}
                          />
                        )),
                        <td
                          className={`py-1.5 pr-2`}
                          children={
                            <div
                              className={`flex justify-end gap-0.5 opacity-0 transition group-hover:opacity-100 focus-within:opacity-100 max-sm:opacity-100`}
                              children={[
                                <button
                                  type={`button`}
                                  onClick={() => v(e)}
                                  aria-label={`Editar ${h(e)}`}
                                  className={`rounded-lg p-2 text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
                                  children={(0, JSXRuntime.jsx)(wi, {
                                    className: `h-3.5 w-3.5`,
                                  })}
                                />,
                                <button
                                  type={`button`}
                                  onClick={() => y(e)}
                                  aria-label={`${e.activo ? `Dejar de usar` : `Volver a usar`} ${h(e)}`}
                                  className={`rounded-lg p-2 text-(--text) ${e.activo ? `hover:bg-(--panel) hover:text-(--error)` : `hover:bg-(--accent-bg) hover:text-(--accent)`}`}
                                  children={
                                    e.activo ? (
                                      <Ei className={`h-3.5 w-3.5`} />
                                    ) : (
                                      <Di className={`h-3.5 w-3.5`} />
                                    )
                                  }
                                />,
                              ]}
                            />
                          }
                        />,
                      ]}
                    />
                  ))}
                />,
              ]}
            />
          }
        />
      )),
      (t[0] = o),
      (t[1] = f),
      (t[2] = _),
      (t[3] = l),
      (t[4] = r),
      (t[5] = d),
      (t[6] = h),
      (t[7] = y),
      (t[8] = s),
      (t[9] = v),
      (t[10] = a),
      (t[11] = c),
      (t[12] = i),
      (t[13] = m),
      (t[14] = p),
      (t[15] = n),
      (t[16] = u),
      (t[17] = b),
      (t[18] = x),
      (t[19] = S),
      (t[20] = C));
  } else ((b = t[17]), (x = t[18]), (S = t[19]), (C = t[20]));
  let w;
  t[44] === d.length
    ? (w = t[45])
    : ((w = d.length > d$ && (
        <p
          className={`text-xs text-(--text)`}
          children={[
            `Se muestran `,
            d$,
            ` de `,
            d.length,
            `. Buscá para llegar al que necesitás.`,
          ]}
        />
      )),
      (t[44] = d.length),
      (t[45] = w));
  let T;
  return (
    t[46] !== b || t[47] !== x || t[48] !== S || t[49] !== C || t[50] !== w
      ? ((T = <section className={b} children={[x, S, C, w]} />),
        (t[46] = b),
        (t[47] = x),
        (t[48] = S),
        (t[49] = C),
        (t[50] = w),
        (t[51] = T))
      : (T = t[51]),
    T
  );
}
